<template>
  <div class="new-phone" v-wechat-title="$route.meta.title">
    <header v-if="!isAPP">
      <div class="left" @click="goBack">
        <img src="../../../image/arrows.png" />
      </div>
      <div class="text">更换手机号码</div>
    </header>
    <div class="formerPhone">
      <div class="left">当前手机号</div>
      <div class="right">{{ hideNum }}</div>
    </div>
    <div class="newPhone">
      <input type="tel" placeholder="请输入新手机号码" maxlength="13" v-model="telNum" @keydown="cleanMobileSmsErr" />

      <div v-if="isHighLight" class="getBtn" @click="sendVerify">{{ getAuthCode }}</div>
      <div v-else class="getBtn col">{{ getAuthCode }}</div>
    </div>
    <div class="hint" v-show="isShow">
      <span>{{ errText }}</span>
    </div>
    <div class="form-group" v-show="isShowImgCaptcha">
      <input class="input-control" v-model="imgCaptchaCode" maxlength="4" placeholder="请输入图形验证码" />
      <img :src="imgCaptchaAddress" alt class="ic-pic" @click="getImgCaptchaCode" />
    </div>
    <div class="errorTip" v-show="isErrorTip">
      <span>{{ errorTip }}</span>
    </div>
    <div class="verification">
      <input type="tel" placeholder="请输入手机验证码" maxlength="6" v-model="verifyCode" />
    </div>
    <div class="verifyHint" v-show="isShowVerify">
      <span>{{ verifyErrText }}</span>
    </div>
    <div class="btn">
      <button class="but1" v-if="isValidButton" @click="submit">确认</button>
      <button class="but1 but2" v-else>
        <span>确认</span>
      </button>
    </div>
  </div>
</template>

<script>
import CONSTANT from '../../../constant'
import cookie from '../../../lib/cookie'
import userService from '../../../service/user'
import { app } from '../../../util/platform'
import { Toast } from 'mint-ui'
import setDocumentTitle from '@util/document-title'
import userManager from '@util/userManager'

const NOTE_VERIFY_CODE = 0
const INPUT_GRAPH_CODE = 6007
const GRAPH_CODE_ERR = 6006
const CAN_CHANGE_PHONE = 0
const NOTE_CODE_ERR = 6101
const NULLITY_USER_ACCREDIT = 6801031
const BLACK_LIST_USER = 6801002

export default {
  data() {
    return {
      isShow: false,
      isShowVerify: false,
      errText: '', //手机格式提示
      telNum: '', //手机号
      verifyCode: '', //验证码
      verifyErrText: '', //验证提示
      getAuthCode: '获取验证码',
      isShowImgCaptcha: false, //是否显示图形验证码
      isErrorTip: false, //是否显示图形验证码错误提示
      phoneNum: userManager.getMobile(),
      imgCaptchaCode: '', //输入的图形验证码
      errorTip: '', //图形验证错误提示
      imgCaptchaAddress: '', //图形验证码
      imgCaptchaKey: '',
      imgCaptchaLength: -1,
      iscol: false,
    }
  },
  computed: {
    isAPP() {
      this.className2 = ''
      return app.isMZMall()
    },
    hideNum() {
      let hideNum = this.phoneNum.substr(0, 3) + '****' + this.phoneNum.substr(7)
      return hideNum
    },
    isValidPhone() {
      var phone = this.telNum.replace(/\s/g, '')
      // console.log(phone)
      if (!/^1[3456789]\d{9}$/.test(phone)) {
        return false
      }
      return true
    },
    isHighLight() {
      return this.isValidPhone && !this.iscol
    },
    isValidButton() {
      return (
        this.isValidPhone &&
        (this.verifyCode + '').length > 0 &&
        (((this.imgCaptchaCode + '').length > 0 && this.isShowImgCaptcha) || (this.imgCaptchaCode == '' && !this.isShowImgCaptcha))
      )
    },
  },
  mounted() {
    setDocumentTitle('更换手机号码')
  },
  methods: {
    cleanMobileSmsErr() {
      const mobile = this.telNum.replace(/\s/g, '')
      this.telNum = this.formatNumber(mobile)
    },
    formatNumber(str) {
      const string = str
      const len = string.length || 0
      if (len <= 3) {
        return string
      } else if (len > 3 && len <= 7) {
        return string.substr(0, 3) + ' ' + string.substr(3, 4)
      } else if (len > 7 && len <= 11) {
        return string.substr(0, 3) + ' ' + string.substr(3, 4) + ' ' + string.substr(7, 4)
      } else {
        return string
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    sendVerify() {
      const mobile = this.telNum.replace(/\s/g, '')
      userService
        .sendSmsCode({
          type: CONSTANT.USER_SMS_CODE_TYPE_IS_SET_PHONE_COOD,
          mobile: mobile,
          imgKey: this.imgCaptchaKey, //图片验证码key，根据redis错误次数判断是否需要验证码
          imgCode: this.imgCaptchaCode, //图片验证码答案
          operatorId: Number(cookie(CONSTANT.COOKIE_KAOP_OPERATION_ID)) || 0,
        })
        .then((data) => {
          if (data.status === NOTE_VERIFY_CODE) {
            this.isShow = false
            this.isShowVerify = false
            this.isErrorTip = false
            this.iscol = true
            let time = 60
            let countDown = setInterval(() => {
              time--
              this.getAuthCode = `${time} 秒`
              if (time <= 0) {
                this.iscol = false
                this.getAuthCode = '获取验证码'
                clearInterval(countDown)
              }
            }, 1000)
          } else if (data.status === GRAPH_CODE_ERR || data.status === INPUT_GRAPH_CODE) {
            this.verifyErrText = data.msg
            this.isShowVerify = true
            this.isShowImgCaptcha = true
            this.getImgCaptchaCode()
          } else {
            Toast({
              message: data.msg,
              position: 'bottom',
              duration: 2000,
            })
          }
        })
        .catch((err) => {})
    },
    submit() {
      const mobile = this.telNum.replace(/\s/g, '')
      if (mobile == this.phoneNum) {
        this.errText = '新更换的手机号码不能为当前手机号码'
        this.isShow = true
        return
      }
      userService
        .mobileChange({
          authToken: sessionStorage.getItem(CONSTANT.CHANGE_PHONE_TOKEN), // 更换手机号的授权令牌
          mobile: mobile, // 新手机号
          smsCode: this.verifyCode, // 新手机号接收的验证码
        })
        .then((data) => {
          if (data.status === CAN_CHANGE_PHONE) {
            this.isShowVerify = false
            this.$router.push('/login/user/change_succeed')
            userManager.setMobile(mobile)
          } else if (data.status === NOTE_CODE_ERR) {
            this.verifyErrText = '短信验证码错误，请重新输入'
            this.isShowVerify = true
          } else if (data.status === NULLITY_USER_ACCREDIT) {
            Toast({
              message: '短信授权已过期,请重新验证',
              position: 'bottom',
              duration: 2000,
            })
            setTimeout(() => {
              this.$router.push('/login/user/verify')
              sessionStorage.removeItem(CONSTANT.CHANGE_PHONE_TOKEN)
            }, 2000)
          } else if (data.status === BLACK_LIST_USER) {
            this.errText = '该手机号码已绑定其他账户，请更换其他手机号码'
            this.isShow = true
          } else {
            Toast({
              message: data.msg,
              position: 'bottom',
              duration: 2000,
            })
          }
        })
        .catch((err) => {})
    },
    getImgCaptchaCode() {
      const self = this
      // self.imgCaptchaType = type
      userService
        .getImgCaptcha()
        .then((data) => {
          self.imgCaptchaAddress = data.imgUrl
          self.imgCaptchaKey = data.imgKey
          self.imgCaptchaLength = data.length
        })
        .catch((e) => {
          this.errorTip = e.msg
        })
    },
  },
  watch: {
    telNum() {
      if (this.telNum.length == 0) {
        this.isShow = false
      } else if (this.telNum.length == 13) {
      }
    },
    imgCaptchaCode() {
      if (this.imgCaptchaCode == '') {
        this.isErrorTip = false
      }
    },
    verifyCode() {
      if (this.verifyCode == '') {
        this.isShowVerify = false
      }
    },
  },
}
</script>

<style lang="less">
.new-phone {
  width: 100%;
  height: 100%;
  header {
    width: 100%;
    height: 44px;
    position: relative;
    background-color: #fff;
    border-bottom: 0.5px solid rgb(237, 237, 237);

    .left {
      width: 44px;
      height: 44px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        display: block;
        width: 11px;
        height: 19px;
      }
    }
    .text {
      width: 103px;
      height: 24px;
      position: absolute;
      top: 10px;
      left: 136px;
      text-align: center;
      line-height: 24px;
      font-size: 17px;
      color: rgb(25, 26, 27);
    }
  }
  .icon {
    width: 100%;
    height: 36px;
    display: flex;
    justify-content: center;
    margin-top: 36px;
    img {
      width: 135px;
      height: 36px;
    }
  }
  .formerPhone {
    width: 92%;
    height: 19px;
    margin: 64px auto 0;
    .left {
      float: left;
      font-size: 13px;
      color: rgb(25, 26, 27);
    }
    .right {
      float: right;
      font-size: 13px;
      color: rgb(25, 26, 27);
    }
  }
  .newPhone {
    width: 92%;
    height: 50px;
    margin: 15px auto 0;
    border-bottom: 0.5px solid rgb(237, 237, 237);
    input {
      width: 70%px;
      height: 20px;
      float: left;
      margin-top: 15px;
      font-size: 13px;
      outline: none;
      border: none;
    }
    .getBtn {
      width: 80px;
      height: 20px;
      float: right;
      margin-top: 15px;
      text-align: center;
      font-size: 13px;
      // color: black;
      color: rgb(25, 26, 27);
    }
    .col {
      color: rgb(189, 192, 197);
    }
  }
  .hint {
    width: 92%;
    height: 16px;
    margin: 0 auto;
    margin-top: 5px;
    span {
      font-size: 12px;
      color: rgb(192, 49, 49);
    }
  }
  .form-group {
    width: 92%;
    height: 50px;
    margin: 0 auto;
    border-bottom: 0.5px solid rgb(237, 237, 237);
    .input-control {
      width: 70%;
      height: 20px;
      float: left;
      margin-top: 15px;
      font-size: 13px;
      outline: none;
      border: none;
    }
    .ic-pic {
      width: 80px;
      height: 30px;
      float: right;
      margin-top: 15px;
      text-align: center;
      color: rgb(189, 192, 197);
    }
  }
  .errorTip {
    width: 92%;
    height: 16px;
    margin: 0 auto;
    margin-top: 5px;
    span {
      font-size: 12px;
      color: rgb(192, 49, 49);
    }
  }
  .verification {
    width: 92%;
    height: 50px;
    margin: 0 auto;
    border-bottom: 0.5px solid rgb(237, 237, 237);
    input {
      width: 100%;
      float: left;
      margin-top: 15px;
      font-size: 13px;
      outline: none;
      border: none;
    }
  }
  .verifyHint {
    width: 92%;
    height: 16px;
    margin: 0 auto;
    margin-top: 5px;
    span {
      font-size: 12px;
      color: rgb(192, 49, 49);
    }
  }
  .btn {
    width: 100%;
    height: 44px;
    display: flex;
    justify-content: center;
    margin-top: 46px;
    .but1 {
      width: 300px;
      height: 100%;
      border-radius: 4px;
      background-color: rgb(192, 49, 49);
      color: #fff;
      font-size: 15px;
      border: 1px solid transparent; //自定义边框
      outline: none; //消除默认点击蓝色边框效果
    }
    .but2 {
      span {
        opacity: 0.3;
      }
    }
  }
}
</style>
